import Navbar from "../Navbar/Navbar";
import "./Header.css";

function Header() {
  return (
    <header className="header df fdr aic">
      <Navbar />
    </header>
  );
}

export default Header;
